module.exports = {
  __depends__: [ require(170) ],
  __init__: [ 'touchInteractionEvents' ],
  touchInteractionEvents: [ 'type', require(246) ],
  touchFix: [ 'type', require(245) ]
};